module.exports = __webpack_public_path__ + "bdcc1a96360967aa480eb1b8a8acba65.svg";